import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × PRADA: Rational sensuality
// Triangular motifs, neon accents, bold contrasts
export function VasarelyPradaMode({ brand }: ModeRendererProps) {
  const pradaRed = "#DC143C";

  return (
    <g>
      {/* Black background */}
      <rect x="0" y="0" width="794" height="1123" fill={brand.black} />

      <g transform="translate(397 540)">
        {/* Triangular motif grid */}
        {Array.from({ length: 14 }).map((_, i) =>
          Array.from({ length: 18 }).map((_, j) => {
            const x = (i - 6.5) * 48;
            const y = (j - 8.5) * 44;
            const upward = (i + j) % 2 === 0;
            const size = 20;
            
            const points = upward
              ? `${x},${y - size} ${x - size},${y + size} ${x + size},${y + size}`
              : `${x},${y + size} ${x - size},${y - size} ${x + size},${y - size}`;
            
            return (
              <polygon
                key={`${i}-${j}`}
                points={points}
                fill={pradaRed}
                opacity="0.2"
                stroke={brand.white}
                strokeWidth="1"
              />
            );
          })
        )}

        {/* Bold contrast lines */}
        {Array.from({ length: 16 }).map((_, i) => {
          const angle = (i * Math.PI) / 8;
          return (
            <line
              key={i}
              x1="0"
              y1="0"
              x2={Math.cos(angle) * 280}
              y2={Math.sin(angle) * 280}
              stroke={pradaRed}
              strokeWidth="2"
              opacity="0.3"
            />
          );
        })}

        {/* Neon accent circles */}
        {Array.from({ length: 14 }).map((_, i) => {
          const r = 40 + i * 18;
          return (
            <circle
              key={i}
              cx="0"
              cy="0"
              r={r}
              fill="none"
              stroke={i % 2 === 0 ? pradaRed : brand.violet}
              strokeWidth="1.5"
              opacity={0.4 - i * 0.02}
            />
          );
        })}

        {/* Rational geometry nodes */}
        {[0, 60, 120, 180, 240, 300].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 200;
          
          return (
            <g key={angle}>
              {/* Triangle marker */}
              <polygon
                points={`
                  ${Math.cos(rad) * r},${Math.sin(rad) * r - 12}
                  ${Math.cos(rad) * r - 10},${Math.sin(rad) * r + 8}
                  ${Math.cos(rad) * r + 10},${Math.sin(rad) * r + 8}
                `}
                fill={pradaRed}
                opacity="0.7"
              />
              <polygon
                points={`
                  ${Math.cos(rad) * r},${Math.sin(rad) * r - 12}
                  ${Math.cos(rad) * r - 10},${Math.sin(rad) * r + 8}
                  ${Math.cos(rad) * r + 10},${Math.sin(rad) * r + 8}
                `}
                fill="none"
                stroke={brand.white}
                strokeWidth="2"
                opacity="0.5"
              />
            </g>
          );
        })}

        {/* Central triangle tension */}
        <polygon
          points="0,-60 -52,30 52,30"
          fill={pradaRed}
          opacity="0.3"
        />
        <polygon
          points="0,-60 -52,30 52,30"
          fill="none"
          stroke={brand.violet}
          strokeWidth="3"
          opacity="0.7"
        />

        {/* Sensual curve accents */}
        {[-1, 1].map((dir) => {
          const points = Array.from({ length: 30 }).map((_, i) => {
            const t = i / 29;
            const x = dir * (t * 200 - 100);
            const y = -120 + t * 240;
            const curve = Math.sin(t * Math.PI * 3) * 30;
            return `${x + curve},${y}`;
          }).join(" ");
          
          return (
            <polyline
              key={dir}
              points={points}
              fill="none"
              stroke={brand.violet}
              strokeWidth="2"
              opacity="0.4"
            />
          );
        })}
      </g>

      {/* Prada text */}
      <text x="397" y="1020" textAnchor="middle" fontFamily="sans-serif" fontWeight="700" fontSize="12" fill={pradaRed} opacity="0.8">
        SENSUALITÉ RATIONNELLE
      </text>
    </g>
  );
}
